import Client1 from "../../assets/img/content/clients/1.png";
import Client2 from "../../assets/img/content/clients/2.png";
import Client3 from "../../assets/img/content/clients/3.png";
import Client4 from "../../assets/img/content/clients/4.png";
import Client5 from "../../assets/img/content/clients/5.png";
import Client6 from "../../assets/img/content/clients/6.png";
import Client7 from "../../assets/img/content/clients/7.png";
import Client8 from "../../assets/img/content/clients/8.png";
import Client9 from "../../assets/img/content/clients/9.png";
import Client10 from "../../assets/img/content/clients/10.png";
import Client11 from "../../assets/img/content/clients/11.png";
import Client12 from "../../assets/img/content/clients/12.png";
import Client13 from "../../assets/img/content/clients/13.png";
import Client14 from "../../assets/img/content/clients/14.png";
import Client15 from "../../assets/img/content/clients/15.png";
import Client16 from "../../assets/img/content/clients/16.png";
import Client17 from "../../assets/img/content/clients/17.png";
import Client18 from "../../assets/img/content/clients/18.png";
import "./ClientsComponent.css";

import clientCarousel from "../../assets/clientCarousel.json";
const clients: ClientItem[] = clientCarousel as ClientItem[];

const imageMap: Record<string, string> = {
  Client1,
  Client2,
  Client3,
  Client4,
  Client5,
  Client6,
  Client7,
  Client8,
  Client9,
  Client10,
  Client11,
  Client12,
  Client13,
  Client14,
  Client15,
  Client16,
  Client17,
  Client18
};

type ClientItem = {
  name: string;
  image: string;
  alt: string;
  url: string;
};



const SliderComponent = () => {
    return (
        <div className="section-clients bg-light">
            <div className="text-center ">
                <div className="container-body">
                    <div className="text-center section-heading">
                        <h2 className="section-title">Our Clients</h2>
                        <p className="w-95 w-md-75 w-lg-55 section-info">Discover the achievements of hundreds of leading organizations who have strengthened their teams and reached new heights by partnering with us for talent assessments and hiring excellence.
                        </p>
                    </div>
                    <div className="section-clients-logos">
                        <div className="logo-carousel">
                            <div className="carousel-track">
                                {clients.concat(clients).map((client, idx) => (
                                    <a href={client.url} target="_blank" key={idx}>
                                        <img src={imageMap[client.image]} alt={client.alt} />
                                    </a>
                                ))}
                            </div>

                        </div>
                    </div>
                    <p className=" section-info">We will be delighted to have you as our client. Please mail us at <a href="mailto:info@iaminterviewed.com">info@iaminterviewed.com</a> to know the list of our clients.</p>
                </div>
            </div>
        </div>
    );
};
export default SliderComponent;